import { useState } from "react";
import { FeriasInputCard } from "./components/FeriasInputCard";
import { ResponseSalario } from "./Ferias";
import { FeriasResponse } from "./components/FeriasResponse";

export default function SalarioFerias() {
    const [results, setResults] = useState<ResponseSalario | null>(null);

    return (
        <>

            <FeriasInputCard setResults={setResults} />

            {results && <FeriasResponse results={results} />}

        </>
    );
}
